import { Col, Row } from "react-bootstrap";
import React from "react";
import { useTranslation } from "react-i18next";
import {NFTextAreaInput} from "src/components/Shared/NewForms/NFTextAreaInput";
import {NFCheckBoxInput} from "src/components/Shared/NewForms/NFCheckBoxInput";
import {NFLookupPurchaseOrder} from "src/components/Shared/NewForms/NFLookupPurchaseOrder";
import {NFTextInput} from "src/components/Shared/NewForms/NFTextInput";
import {NFDateInput} from "src/components/Shared/NewForms/NFDateInput";

export const VendorInvoicesDetailAdditional = () => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextAreaInput
                        fieldName={"comment"}
                        title={t("Comment")}
                        required={false}
                    />
                </Col>
                <Col sm={6}>
                    <NFCheckBoxInput
                        title={t("PriceIncludesVAT")}
                        fieldName={"priceIncludesVat"}
                    />
                </Col>
            </Row>
            <div className="row">
                <div className="col-sm-12">
                    <NFLookupPurchaseOrder fieldName={"baseDocumentAtId"} title={t("PurchaseOrder")} />
                </div>
            </div>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("CreatedUser")}
                        fieldName={"createdUser"}
                        disabled={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("CreatedDate")}
                        fieldName={"createdDate"}
                        disabled={true}
                    />
                </Col>
            </Row>
        </>
    );
};
